import { API } from "../axios/API";

const createComunicacion = async (newData) => {
  try {
    console.log("newData ", newData);
    const resp = await API.post("/comunicaciones/createcomunicacion", newData);
    // const resp = await API.post("/profesionales/createAbogado", newData);
    return resp;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};

const getComunicaciones = async () => {
  // return arrayData;
  try {
    const resp = await API.get("/comunicaciones");
    // const resp = await API.post("/comunicaciones", { dni });
    return resp;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};

const deleteComunicacionById = async (id) => {
  // return arrayData;
  try {
    const result = await API.delete(`/comunicaciones/deleteComunicaciones/${id}`);

    return result;
  } catch (err) {
    return err.response;
  }
};

const updateComunicacionById = async (id, newData) => {
  // return arrayData;
  try {
    const resp = await API.put(`/comunicaciones/updateComunicaciones/${id}`, newData);

    return resp;
  } catch (err) {
    return err.response;
  }
};







const getComunicacionById = async () => {
  // return arrayData;
  try {
    const resp = await API.get("/profesionales/abogados");
    return resp.data;
  } catch (err) {
    return err.response;
  }
};



export const ComunicacionesService = {
  createComunicacion,
  getComunicaciones,
  getComunicacionById,
  updateComunicacionById,
  deleteComunicacionById
};
